
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class TLoading extends Vue {
  @Prop({
    type: String,
    default: '#4f93fe',
  }) color!: string;

  @Prop({
    type: Boolean,
    default: false,
  }) loading!: boolean;

  @Prop(String) text?: string;

  @Prop(Number) width?: number;
}
